// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CollectionCategoryView_Wrapper__3TE2x","Description":"CollectionCategoryView_Description__1h7_R","BackButton":"CollectionCategoryView_BackButton__xmKRG"};